module.exports = __webpack_public_path__ + "img/图层 4.3840f351.png";